import React from 'react';
import VideoUploaderForStyleSettings from 'components/VideoUploader/VideoUploaderForStyleSettings';

interface ICarouselVideoItem {
	translationId: string;
	isMakeImageRequest: boolean;
}

const CarouselVideoItem: React.FC<ICarouselVideoItem> = ({ translationId, isMakeImageRequest }) => {
	return (
		<VideoUploaderForStyleSettings
			translationID={translationId}
			isMakeImageRequest={isMakeImageRequest}
			loaderSize="big"
			isShowControls={true}
		/>
	);
};

export default React.memo(CarouselVideoItem);
